  <img [src]="imageUrl" class="rounded loan-image-url" [style.width.px]="size" [style.height.px]="size" (load)="onImageLoaded()" (error)="onImageError()">
  <span [style.background-image]="imageUrl ? 'url(' + imageUrl + ')' : ''"></span>
